// extracted by mini-css-extract-plugin
export default {"Button":"index-module__Button--OtobH","Box":"index-module__Box--frePM","NavList":"index-module__NavList--rdIJd"};